import React from 'react';
import { Modal } from 'react-bootstrap';

interface KycDocumentsModalProps {
    user: any;
    show: boolean;
    onClose: () => void;
}

export const KycDocumentsModal: React.FC<KycDocumentsModalProps> = ({ user, show, onClose }) => {

    const getDocumentByType = (docType: string) => {
        return user?.kycDocument?.find((doc: any) => doc.docType === docType);
    };

    const handleClose = () => {
        onClose();
    };

    const getPoeUrl = () => {
        const poeDoc = user?.kycDocument?.find((doc: any) => doc?.docType === 'POE');
        return poeDoc?.docUrl || null;
    };

    const getPoiUrl = () => {
        const poiDoc = user?.kycDocument?.find((doc: any) => doc?.docType === 'POI');
        return poiDoc?.docUrl || null;
    };

    const getPofUrl = () => {
        const pofDoc = user?.kycDocument?.find((doc: any) => doc?.docType === 'POF');
        return pofDoc?.docUrl || null;
    };

    return (
        <Modal
            className='modal fade'
            id='kt_modal_view_user'
            data-backdrop='static'
            tabIndex={-1}
            role='dialog'
            show={show}
            centered
            size="lg"
        >
            <div className="modal-content">
                <div className="modal-header pb-0 border-0 justify-content-end">
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={handleClose}>
                        ×
                    </div>
                </div>

                <div className="modal-body scroll-y mx-5 mx-xl-18 pt-0">
                    <div className="text-center mb-13">
                        <h1 className="mb-3">KYC documents</h1>
                    </div>

                    <div className="table-responsive">
                        <table style={{
                            width: '100%',
                            borderCollapse: 'collapse',
                            marginBottom: '20px',
                            tableLayout: 'fixed'
                        }}>
                            <thead>
                                <tr className="fw-bold bg-light">
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#333333', color: "white", fontWeight: 600 }}>Environment Permit</th>
                                    <th style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd', backgroundColor: '#333333', color: "white", fontWeight: 600 }}>Business registration</th>

                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {getDocumentByType('POE')?.docNumber || 'N/A'}
                                        </span>
                                    </td>
                                    <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {getDocumentByType('POI')?.docNumber || 'N/A'}
                                        </span>
                                    </td>
                                    {/* <td style={{ padding: '10px', textAlign: 'left', border: '1px solid #ddd' }}>
                                        <span className="text-dark fw-semibold d-block fs-6">
                                            {getDocumentByType('POF')?.docNumber || 'N/A'}
                                        </span>
                                    </td> */}
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    {/* Document Images Section */}
                    <div className="mt-5">
                        <div className="row">
                            {/* POE Document */}
                            <div className="col-md-4 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
                                            Facility Picture
                                        </p>
                                    </div>
                                    <div className="card-body text-center">
                                        {getPoeUrl() ? (
                                            <img
                                                src={getPoeUrl()}
                                                alt="Proof of Establishment"
                                                style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                className="img-fluid cursor-pointer"
                                                onClick={() => window.open(getPoeUrl(), '_blank')}
                                            />
                                        ) : (
                                            <div className="text-dark">No image available</div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* POI Document */}
                            <div className="col-md-4 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>

                                            Environment Permit
                                        </p>
                                    </div>
                                    <div className="card-body text-center">
                                        {getPoiUrl() ? (
                                            <img
                                                src={getPoiUrl()}
                                                alt="Proof of Identity"
                                                style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                className="img-fluid cursor-pointer"
                                                onClick={() => window.open(getPoiUrl(), '_blank')}
                                            />
                                        ) : (
                                            <div className="text-dark">No image available</div>
                                        )}
                                    </div>
                                </div>
                            </div>

                            {/* POF Document */}
                            <div className="col-md-4 mb-4">
                                <div className="card">
                                    <div className="card-header">
                                        <p style={{ fontSize: '15px', fontWeight: '600', marginBottom: '0' }}>
                                            Logo
                                        </p>
                                    </div>
                                    <div className="card-body text-center">
                                        {getPofUrl() ? (
                                            <img
                                                src={getPofUrl()}
                                                alt="Proof of Facility"
                                                style={{ width: '100%', maxHeight: '200px', objectFit: 'contain' }}
                                                className="img-fluid cursor-pointer"
                                                onClick={() => window.open(getPofUrl(), '_blank')}
                                            />
                                        ) : (
                                            <div className="text-dark">No image available</div>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="modal-footer">
                        <button
                            type="button"
                            className="btn btn-light"
                            onClick={handleClose}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
        </Modal>
    );
};